import React, { Component, createRef, Suspense } from 'react'
import moment from 'moment'
import { lazyWithRetry } from 'components/lazyUtil.js'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
import { DateRangePicker } from 'react-dates'
import isBeforeDay from '../../elements/dateSelector/airbnbUtils/isBeforeDay'
import { Button } from 'components/elements'
import { withRouter } from 'react-router-dom'
import { getLocation } from '../../context/SearchContainer'
import { trackSearchFromHome } from '../../elements/tracking/searchTracking.js'
import './homeSearchBar.sass'
import './../../theme/assets/styles/global.sass'
import {
  trackSearchLocationFromHome,
  trackSearchLocationAndDatesFromHome,
} from './../../elements/klaviyoTracking/homePageSearch'
import StyleFilter from './styleFilter'
import SearchWizardMobile from './searchWizardMobile'

const Searchbar = lazyWithRetry(() =>
  import('../../theme/searchAutoComplete/searchAutoComplete')
)

const MapboxSearchBar = lazyWithRetry(() =>
  import('../../theme/mapboxSearchAutoComplete/mapboxSearchAutoComplete')
)
const Tippy = lazyWithRetry(() => import('@tippyjs/react'))

const renderLoader = () => <span></span>

class FeaturedSearchInner extends Component {
  constructor(props) {
    super(props)
    this.state = {
      searchLocation: getLocation('location'),
      searchLat: getLocation('lat'),
      searchLng: getLocation('lng'),
      homeDatesOpen: false,
      datesPosition: 'left bottom',
      focusSearch: false,
      locationHelpOpen: false,
      selectedStyles: [],
      openStyleSelector: false,
      showSearchWizard: false,
      step: 0,
    }
  }

  formRef = createRef()

  componentWillUnmount() {
    this.setState({
      focusSearch: false,
    })
  }

  componentDidMount() {
    this.props.onClearLocation()
  }

  setLocationSearchINFO = (
    searchLocation,
    searchLat,
    searchLng,
    updateLocationContainer = null,
  ) => {
    const { startDate, endDate } = this.state

    let focusedInput = this.state.focusedInput

    if (!endDate) {
      focusedInput = 'endDate'
    }

    if (!startDate) {
      focusedInput = 'startDate'
    }

    this.setState({
      searchLocation,
      searchLat,
      searchLng,
      focusedInput,
      locationHelpOpen: false,
      openMobileDates: !startDate || !endDate,
      focusSearch: false,
      step: 1,
      showSearchWizard: true,
    })
  }

  handleDateChange = (startDate, endDate) => {
    //if user selects single day(one click) and hit search/apply button by default use startDate as endDate
    let tempEndDate = endDate ? endDate : startDate
    this.setState({
      startDate,
      endDate: tempEndDate,
      openMobileDates: !startDate || !tempEndDate,
      openStyleSelector: !!startDate && !!endDate,
      step: !!startDate && !!endDate ? 2 : this.state.step
    })
  }

  submitHomeSearch = (e, updateLocationContainer) => {
    e.preventDefault()
    if (this.state.searchLocation === null) {
      this.setState({
        focusSearch: true,
        locationHelpOpen: true,
      })
      return false
    }

    updateLocationContainer({
      location: this.state.searchLocation,
      lat: this.state.searchLat,
      lng: this.state.searchLng,
    })

    const trackFields = {
      search_location: this.state.searchLocation,
      search_latitude: this.state.searchLat,
      search_longitude: this.state.searchLng,
    }

    let url =
      '/search?location=' +
      this.state.searchLocation +
      '&latitude=' +
      this.state.searchLat +
      '&longitude=' +
      this.state.searchLng

    url += '&min_distance=0&max_distance=75'

    if (this.props.makes) {
      url += '&makes=' + this.props.makes
    }
    if (this.state.startDate && this.state.endDate) {
      trackSearchLocationAndDatesFromHome(
        this.state.searchLocation,
        this.state.startDate.format('YYYY-MM-DD'),
        this.state.endDate.format('YYYY-MM-DD')
      )
      trackFields['start_date'] = this.state.startDate.format('YYYY-MM-DD')
      trackFields['end_date'] = this.state.endDate.format('YYYY-MM-DD')

      url +=
        '&startDate=' +
        this.state.startDate.format('YYYY-MM-DD') +
        '&endDate=' +
        this.state.endDate.format('YYYY-MM-DD')
    } else {
      trackSearchLocationFromHome(this.state.searchLocation)
    }

    if (this.state.selectedStyles.length > 0) {
      trackFields['category'] = this.state.selectedStyles.join(',')
      url += '&category=' + this.state.selectedStyles.join(',')
    }
    // removed "by default all the bikes should be shown i.e. url += '&category=all_styles'"
    // https://trello.com/c/eRYuBkPs/7381-update-to-style-filter

    trackSearchFromHome(trackFields)
    this.props.history.push(url)
  }

  onSearchBlur = () => {
    this.setState({
      focusSearch: false,
    })
  }

  openPopUp = (inputType) => {
    this.setState({ homeDatesOpen: true })
    if (inputType === 'startDate') {
      this.setState({ datesPosition: 'left bottom' })
    }

    if (inputType === 'endDate') {
      this.setState({ datesPosition: 'right bottom' })
    }
  }

  closePopUp = (inputType) => {
    this.setState({ homeDatesOpen: false })
  }

  shouldClearDates = (startDate, endDate) => {
    if (!startDate || !endDate) {
      this.setState({
        startDate: null,
        endDate: null,
      })
    }
  }

  clearHomeDates = () => {
    this.setState({
      startDate: null,
      endDate: null,
    })
  }

  clearStyles = () => {
    this.setState({
      selectedStyles: [],
    })
  }

  onStyleSelect = (styles) => {
    this.setState({ selectedStyles: styles })
  }

  onNextStep = (e) => {
    const { step } = this.state
    if (step < 2) {
      this.setState({step: this.state.step + 1});
    } else {
      this.submitHomeSearch(e, this.props.searchObject.updateLocation)
    }
  }

  onPrevStep = () => {
    this.setState({
      step: this.state.step - 1,
      showSearchWizard: this.state.step > 1,
      focusSearch: this.state.step === 1,
    })
  }

  onStepClear = () => {
    const { step } = this.state
    if (step === 1) {
      this.clearHomeDates()
    } else if (step === 2) {
      this.clearStyles()
    }
  }

  onSearchWizardClose = () => {
    this.setState({
      step: 0,
      showSearchWizard: false,
      focusSearch: true,
      locationHelpOpen: true,
    })
  }

  showClear = () => {
    const { step, startDate, endDate, selectedStyles } = this.state
    let value = false
    if (step === 1 && (!!startDate || !!endDate)) {
      value = true
    } else if (step === 2 && selectedStyles.length > 0) {
      value = true
    }

    return value
  }

  render() {
    let { isMobile, searchObject, defaultLocationName } = this.props
    const { startDate, endDate } = this.state

    return (
      <Suspense fallback={renderLoader()}>
        <div className="location-search-home">
          <div className="location-search-home-inner">
            <form
              ref={this.formRef}
              onSubmit={(e) =>
                this.submitHomeSearch(e, searchObject.updateLocation)
              }
            >
              <div className="columns is-gapless is-vcentered home-page-search-wrap">
                <div
                  className="column is-4 home-page-search-column location-element has-search-element"
                  onClick={() => this.setState({ focusSearch: true })}
                >
                  {!isMobile && (
                    <span className="search-bar-label">Location</span>
                  )}

                  <MapboxSearchBar
                    selectSubmit={false}
                    isMobile={false}
                    onSelect={this.setLocationSearchINFO}
                    size="large"
                    className={`${isMobile ? 'is-medium mb-0' : ''}`}
                    overRideIcon={
                      <i className="far fa-map-marker-alt icon dark-icon location-icon"></i>
                    }
                    searchPlaceHolder="Choose a city (Ex. Miami, FL)"
                    focusSearch={this.state.focusSearch}
                    onBlur={this.onSearchBlur}
                    onFocus={this.scrollToSearchBox}
                    searchObject={searchObject}
                    makes={this.props.makes}
                    searchFrom={`homescreen ${isMobile ? 'mobile' : 'desktop'}`}
                  />
                  {!isMobile && (
                    <Tippy
                      content={'Please enter a location.'}
                      arrow
                      placement="bottom-start"
                      offset={[50, 0]}
                      onClickOutside={() =>
                        this.setState({ locationHelpOpen: false })
                      }
                      onHide={() => this.setState({ locationHelpOpen: false })}
                      visible={this.state.locationHelpOpen}
                    >
                      <span></span>
                    </Tippy>
                  )}
                </div>
                {!isMobile && (
                  <div className="column is-4 home-dates-column">
                    {!isMobile && (
                      <>
                        <div className="columns is-mobile is-gapless home-date-from-until">
                          <div
                            className="column is-6 has-search-element has-date-element"
                            onClick={() =>
                              this.setState({ focusedInput: 'startDate' })
                            }
                          >
                            <span className="search-bar-label">From</span>
                            <div className="control has-icons-left search-bar-icons-calendar">
                              <input
                                className="input"
                                defaultValue={
                                  startDate
                                    ? moment(startDate).format('MM/DD/YYYY')
                                    : ''
                                }
                                placeholder={'Start Date'}
                                onFocus={() =>
                                  this.setState({ focusedInput: 'startDate' })
                                }
                              />
                              <span className="icon is-left is-small">
                                <i
                                  aria-hidden="true"
                                  className="fal fa-calendar-alt icon dark-icon "
                                ></i>
                              </span>
                            </div>
                          </div>
                          <div
                            className="column is-6 has-search-element has-date-element"
                            onClick={() =>
                              this.setState({ focusedInput: 'endDate' })
                            }
                          >
                            <span className="search-bar-label">Until</span>
                            <div className="control has-icons-left search-bar-icons-calendar">
                              <input
                                className="input"
                                defaultValue={
                                  endDate
                                    ? moment(endDate).format('MM/DD/YYYY')
                                    : ''
                                }
                                placeholder={'End Date'}
                                onFocus={() =>
                                  this.setState({ focusedInput: 'endDate' })
                                }
                              />
                              <span className="icon is-left is-small">
                                <i
                                  aria-hidden="true"
                                  className="fal fa-calendar-alt icon dark-icon"
                                ></i>
                              </span>
                            </div>
                          </div>
                        </div>
                        <DateRangePicker
                          startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                          startDateId="startDate" // PropTypes.string.isRequired,
                          endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                          endDateId="endDate" // PropTypes.string.isRequired,
                          onDatesChange={({ startDate, endDate }) =>
                            this.handleDateChange(startDate, endDate)
                          } // PropTypes.func.isRequired,
                          focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                          onFocusChange={(focusedInput) =>
                            this.setState({ focusedInput })
                          } // PropTypes.func.isRequired,
                          anchorDirection={'right'}
                          readOnly={true}
                          block={true}
                          small={true}
                          isOutsideRange={(day) => isBeforeDay(day, moment())}
                          noBorder={true}
                          numberOfMonths={2}
                          minimumNights={0}
                          hideKeyboardShortcutsPanel={true}
                          // withPortal={true}
                          onClose={({ startDate, endDate }) =>
                            this.shouldClearDates(startDate, endDate)
                          }
                        />
                      </>
                    )}
                  </div>
                )}
                {
                  !isMobile && (
                    <div className='column is-3 home-category-column has-search-element'>
                      <StyleFilter
                        open={this.state.openStyleSelector}
                        onOpen={() => this.setState({openStyleSelector: true})}
                        onClose={() => this.setState({openStyleSelector: false})}
                        currentValues={this.state.selectedStyles}
                        onSelect={this.onStyleSelect}
                      />
                    </div>
                  )
                }
                {!isMobile && (
                  <div className="column is-1 home-button-column">
                    {!isMobile && (
                      <div className="search-bar-desktop-button-wrap">
                        <Button
                          className="is-circular home-search-button"
                          type="submit"
                          size="medium"
                        >
                          <span className="icon">
                            <i className="fa fa-search"></i>
                          </span>
                        </Button>
                      </div>
                    )}
                  </div>
                )}
              </div>
              {isMobile && (
                <SearchWizardMobile
                  show={this.state.showSearchWizard}
                  step={this.state.step}
                  onNextStep={this.onNextStep}
                  onPrevStep={this.onPrevStep}
                  onClose={this.onSearchWizardClose}
                  onClear={this.onStepClear}
                  showClear={this.showClear()}
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  onDatesChange={this.handleDateChange}
                  additionalDateProps={{
                    isOutsideRange: (day) => isBeforeDay(day, moment()),
                  }}
                  selectedStyles={this.state.selectedStyles}
                  onStyleSelect={this.onStyleSelect}
                />
              )}
            </form>
          </div>
        </div>
      </Suspense>
    )
  }
}

export default withRouter(FeaturedSearchInner)

FeaturedSearchInner.defaultsProps = {
  isMobile: true,
  onClearLocation: function () { },
  onUpdateLocation: function () { },
  clearOnMount: true,
  searchObject: null,
}
